import { type Lesson } from "@core/grades/types";
import { trans } from "@mongez/localization";
import { BookOpenIcon } from "lucide-react";
import { SectionHeading } from "./CategoryChapterMap";
import { CategoryLessonCard } from "./CategoryLessonCard";

type CategoryLessonsSectionProps = {
  description?: string;
  lessons: Lesson[];
  title?: string;
};

export function CategoryLessonsSection({
  description = trans("categoryDetails.directLessonsHint"),
  lessons,
  title = trans("categoryDetails.directLessons"),
}: CategoryLessonsSectionProps) {
  if (!lessons.length) return null;

  return (
    <section className="mt-10">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <SectionHeading
          icon={<BookOpenIcon className="h-5 w-5" />}
          title={title}
          description={description}
        />
        <span className="dark:bg-primary-950/50 rounded-full bg-primary-50 px-3 py-1.5 text-xs font-black text-primary-700 dark:text-primary-300">
          {trans("categoryDetails.lessonCount", { count: lessons.length })}
        </span>
      </div>

      <div className="mt-5 grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
        {lessons.map((lesson, index) => (
          <CategoryLessonCard index={index} key={lesson.id} lesson={lesson} />
        ))}
      </div>
    </section>
  );
}
